import React, { useState, useContext } from 'react'
import { FarzaaContext } from '../../context/FarzaaContext'

const ProductDetailAction = ({ productDetail }) => {
    const {
        paginatedProducts,
        addToCart,
        addToWishlist
    } = useContext(FarzaaContext)

    const defaultQuantity = 1;
    const [quantity, setQuantity] = useState(defaultQuantity);

    const handleQuantityChange = (newQuantity) => {
        if (newQuantity >= 1 && newQuantity <= productDetail.stock) {
            setQuantity(newQuantity);
        } else if (newQuantity > productDetail.stock) {
            setQuantity(productDetail.stock);
        }
    };

    const setCookie = (name, value, days) => {
        const d = new Date();
        d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000)); 
        const expires = "expires=" + d.toUTCString();
        document.cookie = `${name}=${value}; ${expires}; path=/`;
    };

    const getCookie = (name) => {
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookies = decodedCookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let c = cookies[i].trim();
            if (c.indexOf(name + "=") == 0) {
                return c.substring(name.length + 1, c.length);
            }
        }
        return "";
    };

    const handleAddToCart = () => {
        if (quantity > productDetail.stock) {
            alert(`Số lượng bạn chọn vượt quá số lượng tồn kho (${productDetail.stock}).`);
            return;
        }

        const cartItem = {
            productDetailId: productDetail.productDetailId,
            quantity,
            imageLink: productDetail.imageLink,
            name: productDetail.name
        };

        const existingCart = getCookie('cartItems');
        let cartItems = existingCart ? JSON.parse(existingCart) : [];

        const existingItemIndex = cartItems.findIndex(item => item.productDetailId === cartItem.productDetailId);

        if (existingItemIndex !== -1) {
            const newQuantity = cartItems[existingItemIndex].quantity + quantity;
            if (newQuantity > productDetail.stock) {
                alert(`Số lượng cộng dồn vượt quá số lượng tồn kho (${productDetail.stock}).`);
                return;
            }
            cartItems[existingItemIndex].quantity = newQuantity;
        } else {
            cartItems.push(cartItem);
        }

        setCookie('cartItems', JSON.stringify(cartItems), 1); 
        addToCart(productDetail.productDetailId);
    };

    return (
        <>
            <div className="fz-product-details__actions1">
                <span> Sản phẩm</span>
                <button className="fz-product-details__add-to-cart">
                    {productDetail.name}
                </button>
            </div>

            <div className="fz-product-details__actions">
                <div className="fz-product-details__quantity cart-product__quantity">
                    <button className="minus-btn cart-product__minus" onClick={() => handleQuantityChange(quantity - 1)}>
                        <i className="fa-light fa-minus"></i>
                    </button>
                    <input
                        type="number"
                        name="product-quantity"
                        className="cart-product-quantity-input"
                        value={quantity}
                        onChange={(e) => handleQuantityChange(Math.max(1, Math.min(productDetail.stock, parseInt(e.target.value))))}
                        min="1"
                        max={productDetail.stock}
                    />
                    <button className="plus-btn cart-product__plus" onClick={() => handleQuantityChange(quantity + 1)}>
                        <i className="fa-light fa-plus"></i>
                    </button>
                </div>
                <button onClick={handleAddToCart} className="fz-product-details__add-to-cart">Add to cart</button>
            </div>
        </>
    )
}

export default ProductDetailAction
